/*
timeline.js

de/projekte/chancen-durch-vielfalt.html

tobias.wolf@wagnerwagner.de
*/

(function () {
  function Timeline(element) {
    // elements
    const lineItem = element.querySelector('.timeline__line');
    const itemElements = element.querySelectorAll('.timeline__item');
    const items = [];
    const self = this;

    // functions
    function hideItems(exceptItem) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item !== exceptItem) {
          item.hide();
        }
      }
    }
    function changeHeight(height) {
      lineItem.style.height = `${height}px`;
    }
    function init() {
      for (let i = 0; i < itemElements.length; i++) {
        items.push(new TimelineItem(itemElements[i], self));
      }
      // show last item
      items[items.length - 1].show();
    }
    function handleResize() {
      for (let i = 0; i < itemElements.length; i++) {
        items[i].handleResize();
      }
    }

    // event listener
    window.addEventListener('resize', handleResize);

    // public variables
    this.hideItems = hideItems;
    this.changeHeight = changeHeight;
    this.element = element;

    // init
    init();
  }


  function TimelineItem(element, parentTimeline) {
    const self = this;
    const buttonElement = element.querySelector('.timeline__button');
    const textBoxElement = element.querySelector('.timeline__text-box');
    const textBoxArrowElement = element.querySelector('.timeline__text-box-arrow');
    let imageElement;

    // functions
    function init() {
      position();
      imageElement = element.querySelector('.timeline__image img');
      element.classList.remove('is-visible');
    }
    function show() {
      const height = calculateHeight();
      parentTimeline.hideItems(self);
      parentTimeline.changeHeight(height);
      element.classList.add('is-visible');

      // When image is heigher than text, the image would be cut off by default
      // => Resize timeline after image is loaded (has height).
      if (imageElement) {
        if (imageElement.offsetHeight > 0) {
          // double check if element still is visible
          if (element.classList.contains('is-visible')) {
            parentTimeline.changeHeight(height);
          }
        } else {
          imageElement.addEventListener('load', show);
        }
      }
    }
    function hide() {
      element.classList.remove('is-visible');
      textBoxElement.style.visibility = 'visible';
      setTimeout(() => {
        textBoxElement.style.visibility = null;
      }, TRANSITION_DURATION);
    }
    function position() {
      const rightEnd = element.offsetLeft + element.offsetWidth / 2 + textBoxElement.offsetWidth / 2;
      const leftEnd = element.offsetLeft + element.offsetWidth / 2 - textBoxElement.offsetWidth / 2;
      const parentWidth = parentTimeline.element.offsetWidth;
      let padding = 16;
      if (window.matchMedia('(max-width: 655px)').matches) { // media-query_images-not-next-to-text
        padding = 8;
      }
      if (rightEnd > parentWidth) {
        textBoxArrowElement.style.marginLeft = `${rightEnd - parentWidth + padding}px`;
        textBoxElement.style.left = `calc(50% + ${(rightEnd - parentWidth + padding) * -1}px)`;
      } else if (leftEnd < 0) {
        textBoxArrowElement.style.marginLeft = `${leftEnd - padding}px`;
        textBoxElement.style.left = `calc(50% + ${(leftEnd - padding) * -1}px)`;
      } else {
        textBoxArrowElement.style.marginLeft = null;
        textBoxElement.style.left = null;
      }
    }
    function calculateHeight() {
      const height = textBoxElement.offsetTop + textBoxElement.offsetHeight;
      return height;
    }

    function handleResize() {
      position();
      if (element.classList.contains('is-visible')) {
        const height = calculateHeight();
        parentTimeline.changeHeight(height);
      }
    }

    function handleClick() {
      if (!element.classList.contains('is-visible')) {
        show();
      }
    }

    // event listeners
    buttonElement.addEventListener('click', handleClick);

    // init
    init();

    // public variables
    this.show = show;
    this.hide = hide;
    this.handleResize = handleResize;
  }


  // elements
  const elements = document.querySelectorAll('.timeline');

  function init() {
    for (let i = 0; i < elements.length; i++) {
      new Timeline(elements[i]);
    }
  }

  // init
  init();
}());
